export const QUERY_CLIENT = "QUERY_CLIENT";
export const QUERY_CLIENT_LIST = "QUERY_CLIENT_LIST";
export const QUERY_ALL_CLIENT_LIST = "QUERY_ALL_CLIENT_LIST";
